import AccordionDetails, { type AccordionItem } from "@components/Accordion";
import RichTextRenderer from "@components/RichTextRenderer";
import clsx from "clsx";

import type { Context } from "types/context/Context";

import CFContentArea from "../cFContentArea";
import accordionStyles from "./Accordion.module.css";
import type { AccordionBlockType_accordionBlock } from "./queries/contentfulTypes/AccordionBlockType";

interface IAccordionBlockProps {
  blockData: AccordionBlockType_accordionBlock;
  context?: Context;
  uniqueKey?: string;
  maxWidth: number;
}

export default function AccordionBlock({
  blockData: accordionBlock,
  context,
  uniqueKey,
  maxWidth,
}: IAccordionBlockProps) {
  const items: AccordionItem[] = [
    {
      id: accordionBlock.sys?.id ?? uniqueKey ?? undefined,
      question: accordionBlock?.heading ?? "",
      expanded: !!accordionBlock?.expanded,
      answer: (
        <div className={accordionStyles.accordionWrapper}>
          {accordionBlock?.text?.json && (
            <RichTextRenderer json={accordionBlock.text.json} links={accordionBlock.text.links} />
          )}
          {accordionBlock?.contentAreaCollection?.items?.length ? (
            <CFContentArea
              desktopColumns={1}
              contentAreaItems={accordionBlock.contentAreaCollection.items}
              context={context}
              heading={context?.heading?.childLevel}
              maxWidth={maxWidth}
            />
          ) : null}
        </div>
      ),
    },
  ];

  return (
    <section
      data-blockname="expanderbart innehåll"
      data-contentful-entry-id={accordionBlock.sys?.id}
      data-contentful-field-id="name"
      className={clsx(accordionStyles.accordion, "print-noborder")}
    >
      <AccordionDetails
        variant="default"
        items={items}
        headingTag={context?.heading?.parentLevel}
        className="variant-default"
        tracking={{
          event: "accordion_click",
          insurance: context?.insuranceName,
        }}
      />
    </section>
  );
}
